function addClassOnCtaGatedItem() {
    const body = document.querySelector('body');
    const checkCTA = document.querySelector('.embed-cta');
    if (checkCTA || body) {
        body.classList.add('ctaGated');
    } else {
        body.classList.add('notCtaGated');
    }
}

function replaceSearchOnMobile() {
    const searchDiv = document.querySelector('.relativeDiv--search');
    const sideBar = document.querySelector('#left-nav-phone .overlay-scroller');
    if (searchDiv || sideBar) {
        if (window.outerWidth <= 860) {
            const search = searchDiv.cloneNode(true);
            sideBar.appendChild(search);
            const sideSearch = document.querySelector('#left-nav-phone .overlay-scroller .search-input input');
            const SearchTrigger = document.querySelector('.right-side-btns .search-toggle');
            const exitMenu = document.querySelector('#left-nav-phone .exit-bar a');
            sideSearch.onfocus = function() {
                SearchTrigger.click();
                exitMenu.click();
            };
        }
    }
}
//tiles full width for OB-5715
function homepageFulltile() {
    if (document.querySelector('body').classList.contains('hub-page')) {
        const liTags = document.querySelectorAll('.clearfix li.tile');
        if (liTags) {
            let i = 0;
            liTags.forEach((tags) => {
                if (i === 0) {
                    liTags[0].classList.add('full-width-tile');
                }
                i = i + 7;
                if (liTags[i] !== undefined) {
                    liTags[i].classList.add('full-width-tile');
                }

            });
        }
    }
}

function homeSettings() {
    const bannerSettings = window.streams.HomeSettings;
    const bgImg = bannerSettings.bgPath;
    const mobilebg = bannerSettings.mobileBgColor;
    const title = bannerSettings.title;
    const mobiletitle = bannerSettings.mobileTitle;
    const subtitle = bannerSettings.subtitle;
    const colorCode = bannerSettings.colorCode;

    if (bgImg !== '' && bgImg !== undefined) {
        document.querySelector('.header-wrapper').style.backgroundImage = "url(" + bgImg + ")";
        document.querySelector('.header-wrapper').style.backgroundRepeat = "no-repeat";
        document.querySelector('.primary-logo img').setAttribute('src', bgImg);
    }
    if (mobilebg !== '' && mobilebg !== undefined && window.outerWidth <= 991) {
        document.querySelector('.header-wrapper').setAttribute('style', 'background-color: #' + mobilebg);
    }
    if (mobiletitle !== '' && mobiletitle !== undefined && window.outerWidth <= 415) {
        document.querySelector('.header-intro h2').innerHTML = mobiletitle;
        document.querySelector('.header-intro h2').style.color = colorCode;
    } else if (title !== '' && title !== undefined) {
        document.querySelector('.header-intro h2').innerHTML = title;
        document.querySelector('.header-intro h2').style.color = colorCode;
    }
    if (subtitle !== '' && subtitle !== undefined) {
        if (document.querySelector('p.head-description') === null) {
            const description = document.createElement('p');
            description.classList.add('head-description');
            description.innerHTML = subtitle;
            description.style.color = colorCode;
            document.querySelector('.header-intro h2').insertAdjacentElement('afterend', description);
        }
    }
}

const isInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
};


const handleSideCTATopAlignment = () => {
    const sideCTA = document.querySelector('.cta-item-container .tile.single.cta');
    if (document.querySelector('body.single-page .item-level.with-cta') && sideCTA) {
        if (screen.width > 1350) {
            sideCTA.style.marginTop = '7rem';
            const recoCarousel = document.querySelector('.related-items-container');
            if (recoCarousel && isInViewport(recoCarousel)) {
                sideCTA.style.visibility = 'hidden';
            } else {
                sideCTA.style.visibility = 'visible';
            }
        } else {
            sideCTA.style.marginTop = 'inherit';
        }
    }
};

export { addClassOnCtaGatedItem, replaceSearchOnMobile, homepageFulltile, homeSettings, handleSideCTATopAlignment };


// WEBPACK FOOTER //
// ./script-partials/homeSetting.js